import { useContext, useEffect, useState } from "react";
import "../../../../../styles/workspace_styles/CustomerAdministratorStyles/Invoices/Invoice/Invoice.css";
import { InvoiceContext } from "../InvoiceProvider";
import { billingMicroserviceUrl } from "../../../../../microservices/billing_microservice";
import { AppContext } from "../../../../AppProvider";
import InvoicePreview from "./InvoicePreview";
const Invoice = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        selectedInvoiceSummary,setSelectedInvoiceSummary,
        selectedInvoice,setSelectedInvoice,
    } = useContext(InvoiceContext);
    const fetchSelectedInvoice =  async() =>{
        try{
            if(!selectedInvoiceSummary) return;
            const url = `${billingMicroserviceUrl}/customers/invoices/${selectedInvoiceSummary?.id}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setSelectedInvoice(responseData);
            }
            else if(response.status === 401) logout();
            else if(response.status === 500) throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error(`An error occurred when fetching invoice with ID: ${selectedInvoiceSummary?.id}`,error);
        }
    };
    const disposeWindow = () =>{
        setSelectedInvoiceSummary(null);
        setSelectedInvoice(null);
    };
    useEffect(() =>{
        if(selectedInvoiceSummary && selectedInvoice !== null) setSelectedInvoice(null);
        else if(selectedInvoiceSummary) fetchSelectedInvoice();
    },[selectedInvoiceSummary]);
    useEffect(() =>{
        if(selectedInvoiceSummary && selectedInvoice === null) fetchSelectedInvoice();
    },[selectedInvoice]);
    if(!selectedInvoiceSummary) return null;
    return(
        <div className="customer-administrator-invoice-container">
            <div className="customer-administrator-invoice-container-header">
                <div>
                    <h3>{selectedInvoice?.customerName || 'Loading...'}</h3>
                    <h4>Invoice</h4>
                </div>
                <div>
                    <p onClick={() => disposeWindow()}>&#10006;</p>
                </div>
            </div>
            <div className="customer-administrator-invoice-container-body">
                {selectedInvoice?
                    (
                        <div>
                            <InvoicePreview/>
                        </div>
                    ):(
                        <div className="customer-administrator-loading-selected-invoice-container">
                            <div>
                            </div>
                            <p>Loading invoice...</p>
                        </div>
                    )
                }
            </div>
        </div>
    );
};
export default Invoice;